/**
 * Location Edit Gallery photo model and photo UI
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.location.gallery.photo');
goog.module.declareLegacyNamespace();

const photodestination = goog.require('yext.location.photodestination');

/**
 * Photo Model
 *
 * @constructor
 */
var Photo = function(data) {
  this.checked = data.indeterminate ? undefined : true;
  this.initiallyIndeterminate = data.indeterminate;

  this.description = data.asset.description;
  this.descriptionIndeterminate = false;
  this.descriptionAssetId = undefined;

  this.details = data.asset.details;
  this.detailsIndeterminate = false;
  this.detailsAssetId = undefined;

  this.clickthroughUrl = data.asset.clickthroughUrl;
  this.clickthroughUrlIndeterminate = false;
  this.clickthroughUrlAssetId = undefined;

  this.alternateText = data.asset.alternateText;
  this.alternateTextIndeterminate = false;
  this.alternateTextAssetId = undefined;

  this.destinations = [];
  this.destinationIndeterminate = false;
  this.destinationChanged = false;

  this.assetId = data.asset.id;

  $.extend(true, this, data);
};
const model = Photo;

/**
 * Update the data model and broadcast any changes
 *
 * @param {!Object} data Object containing updates
 */
Photo.prototype.update = function(data) {
  // Type safety
  if (typeof data !== 'object') {
    return;
  }

  var changes = this.getChanges(data);

  if (changes) {
    $.extend(this, changes);
    this.broadcastUpdate(changes);
  }
};

/**
 * Filter an object down to the fields that actually changed
 *
 * @param {!Object} data Object containing updates
 * @return {object|boolean} Returns the difference between the new data
 * and the object or false if nothing changed
 */
Photo.prototype.getChanges = function(data) {
  var changed = false;
  var changes = {};
  for (var prop in data) {
    changed = true;
    if (prop == 'destinations') {
      if (photodestination.different(data[prop], this[prop])) {
        changes[prop] = data[prop].slice(0); // Copy by value
      }
    } else if (data[prop] != this[prop]) {
      changes[prop] = data[prop];
    }
  }
  return changed ? changes : false;
};

/**
 * Broadcast updates to the model using pub/sub pattern
 */
Photo.prototype.broadcastUpdate = function(update) {
  $(this).trigger('updated.photo', update);
};


exports = {
  model,
};
